const BODY_PREVIEW_LIMIT = 200;

function normalizeBodyPreview(body) {
    if (typeof body !== "string" || body.length === 0) return "";

    const normalized = body.replace(/\s+/g, " ").trim();
    if (normalized.length <= BODY_PREVIEW_LIMIT) return normalized;

    return `${normalized.slice(0, BODY_PREVIEW_LIMIT)}...`;
}

async function fetchJsonWithDiagnostics(
    url,
    requestOptions = {},
    diagnosticsOptions = {}
) {
    const {
        context = "HTTP request",
        extra = {},
        logger = console,
        fetchImpl = typeof fetch === "function" ? fetch : null,
    } = diagnosticsOptions;

    if (typeof fetchImpl !== "function") {
        throw new Error("fetchJsonWithDiagnostics requires a fetch implementation");
    }

    const method = requestOptions?.method || "GET";

    let response;
    try {
        response = await fetchImpl(url, requestOptions);
    } catch (error) {
        const message = error?.message || String(error);
        logger.error(`[HTTP Debug] Network failure in ${context}`, {
            ...extra,
            url,
            method,
            error: message,
        });

        return {
            ok: false,
            status: null,
            contentType: null,
            bodyPreview: "",
            data: null,
            error: message,
            response: null,
        };
    }

    const contentType = response?.headers?.get?.("content-type") || "";
    const rawBody = typeof response?.text === "function" ? await response.text() : "";
    const bodyPreview = normalizeBodyPreview(rawBody);

    let data = null;
    if (rawBody) {
        try {
            data = JSON.parse(rawBody);
        } catch (error) {
            logger.error(`[HTTP Debug] Non-JSON response in ${context}`, {
                ...extra,
                url: response?.url || url,
                method,
                status: response?.status ?? null,
                statusText: response?.statusText || null,
                contentType,
                bodyPreview,
                error: error?.message || String(error),
            });

            return {
                ok: false,
                status: response?.status ?? null,
                contentType,
                bodyPreview,
                data: null,
                error: `Expected JSON response but received ${contentType || "unknown content type"}`,
                response,
            };
        }
    }

    const apiError =
        data?.error || data?.message || data?.err || response?.statusText || "Request failed";
    const ok = Boolean(response?.ok) && data?.ok !== false;

    if (!ok) {
        logger.error(`[HTTP Debug] Request failed in ${context}`, {
            ...extra,
            url: response?.url || url,
            method,
            status: response?.status ?? null,
            statusText: response?.statusText || null,
            contentType,
            bodyPreview,
            error: apiError,
        });
    }

    return {
        ok,
        status: response?.status ?? null,
        contentType,
        bodyPreview,
        data,
        error: ok ? null : apiError,
        response,
    };
}

const utils = {
    getEdgeBasePath() {
        const productionEdge = (typeof localStorage === 'undefined') ? process.env.EDGE_URL : '/edge';
        const basePath = (process.env.NODE_ENV === 'production') ? productionEdge : 'http://localhost:3010';
        return basePath;
    },
    fetchJsonWithDiagnostics,
};

export default utils;